import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles';
import { colors } from 'theme';

const useStyles = CreateResponsiveStyle(
  {
    container: {
      height: 90,
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: 25,
      paddingRight: 50,
      backgroundColor: colors.colorPrimary,
      justifyContent: 'space-between',
    },
    drawer_mobile_logo: {
      height: 42,
      width: 204,
      tintColor: colors.white,
    },
    i_notary: { width: 150, height: 60 },
    btn_style: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      
    },
    t_back: { fontFamily: 'DMSans-Bold', color: 'white', fontSize: 18, marginLeft: 10 },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      i_notary: { width: 140, height: 60 },
    },
    [DEVICE_SIZES.XS]: {
      i_notary: { width: 140, height: 60 },
    },
  }
);

export default useStyles;
